import { useState } from "react";
import { stringMin } from "../../core/function/function-generic";
import { UpdateStatus } from "../../core/enum";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { businessInterface } from "../../interfaces/businessInterface";
import { useSelector } from "react-redux";

interface Props {
    name: string;
    idTransaction?:string;
    handleChangeStatus?:any;
}

export const StatusType = ({name, idTransaction, handleChangeStatus} : Props) => {
    const state = useSelector((state:{business :businessInterface})=>state.business);
    const [openStatus ,setopenStatus] = useState(false);

    const handleSubmit = (e:string) =>{
        handleChangeStatus(e, idTransaction);
        setopenStatus(false);
    }

    return (
        <>
        {
            ['pending'].includes(name?.toLowerCase()) && state.typeBusiness === 'OUT' ? (
                <>
                    <div className={` ${openStatus ? 'p-none' : ''} cursor-pointer w-[7.5rem] h-full rounded-full bg-color-${name?.toLowerCase()}`} onClick={()=> setopenStatus(true)}>
                        <span className={`fontPageTitle600`}>{stringMin(name)}</span>
                    </div>
                    <div className={`${openStatus ? 'p-4 statue-md' : 'p-none'}`}>
                        <div className="w-full mt-[-5px] flex justify-end cursor-pointer" onClick={()=> setopenStatus(false)}>
                            <XMarkIcon className="w-4"/>
                        </div>
                        {Object.values(UpdateStatus).map((res: string, index: number) => (
                            <div key={index} className={`mt-2 mb-2 w-full rounded-full cursor-pointer bg-color-${res?.toLowerCase()}`} onClick={()=> handleSubmit(res)}>
                                <span className={`fontPageTitle600`}>{stringMin(res)}</span>
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <div className={`w-[7.5rem] cursor-default rounded-full bg-color-${name?.toLowerCase()}`}>
                    <span className={`fontPageTitle600`}>{stringMin(name)}</span>
                </div>
            )
        }

        </>
    )
}